<template>
    <div>
        <!-- メッセージ -->
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        <v-container>
            <v-row>
                <v-col cols="12" xl="3" lg="3" md="3" sm="3">
                    <v-btn x-large height="56" class="font-size-20 white--text" @click="prevPage" color="blue-grey lighten-3">< 戻る</v-btn>
                </v-col>
                <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                    <label-component fontSize="30" fontWeight="bold">
                        <div v-if="!isDraft && !isReject && agreement.contract_error_status">
                            <v-icon left x-large color="red">mdi-alert-circle-outline</v-icon>
                            <span style="color: red;">送信エラー</span>
                        </div>
                        <div v-if="!isDraft && !isReject && agreement.contract_error_status">
                            <span style="color: red; font-size: 12px;">メールアドレスをご確認いただき再度送信頂くか、お問合せよりご連絡ください。</span>
                        </div>
                        契約概要 {{ statusName }}
                    </label-component>
                </v-col>
                <v-col v-if="isDraft && isCreater">
                    <v-btn class="white--text" large color="blue-grey" @click="confirmDeleteDialog = true">破棄</v-btn>
                    <!-- 削除確認ダイアログ -->
                    <simple-dialog-component v-if="confirmDeleteDialog" :dialog.sync="confirmDeleteDialog" @clickOk="deleteDraft" okBtn="破棄" cancelbtn="キャンセル">
                        <div>破棄してよろしいですか？</div>
                    </simple-dialog-component>
                </v-col>
                <v-col v-if="(isApplying || isVerifi) && isCreater">
                    <v-btn class="white--text" large color="red" @click="confirmCancelDialog = true">
                        取り下げる
                    </v-btn>
                    <!-- 取り下げ確認ダイアログ -->
                    <v-dialog v-model="confirmCancelDialog" :dialog.sync="confirmCancelDialog" width="60%">
                        <validation-observer ref="observer" v-slot="{ invalid }" >
                            <v-card color="#F4FEFB">
                                <v-card-title class="justify-center">
                                    送信を取り下げ却下フォルダへ移動します。<br>
                                    実行しますか？
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col class="py-0">
                                            <badge-component tile content="任 意">
                                                <label-component horizontal="left">■取り下げ理由</label-component>
                                            </badge-component>
                                            <br>
                                            ※依頼メールを受け取っている関係者に通知されます。
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <validation-provider v-slot="{ errors }" name="rejectionReason" rules="max:10000">
                                                <v-textarea auto-grow outlined v-disabled-icon-focus clearable rows="3" v-model="rejection_reason" background-color="white"></v-textarea>
                                            </validation-provider>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions class="justify-center">
                                    <v-btn width="30%" class="white--text mb-8" color="red" x-large :disabled="invalid" @click="cancellation">
                                        契約を取り下げる
                                    </v-btn>
                                    <v-btn width="30%" class="white--text mb-8 ml-8" color="blue-grey darken-1" x-large @click="confirmCancelDialog = false">
                                        キャンセル
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </validation-observer>
                    </v-dialog>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" xl="2" lg="2" md="2" sm="2"></v-col>
                <v-col cols="12" xl="7" lg="7" md="7" sm="7">
                    <div class="font-size-20 font-weight-bold">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <span class="info-to" v-bind="attrs" v-on="on">{{ agreement.contract_name }}</span>
                            </template>
                            <span>{{ agreement.contract_name }}</span>
                        </v-tooltip>
                    </div>
                    <div class="font-size-20" v-if="agreement.signature_method">
                        <span>署名方式：{{ getSignatureMethodText(agreement.signature_method) }}</span>
                    </div>
                    <div class="font-size-20">
                        {{ conclusionDateAndTime }}
                    </div>
                </v-col>
                <v-col cols="12" l="3" lg="3" md="3" sm="3">
                    <v-menu v-if="enableDownload" v-model="openMenu" left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" class="font-size-20 white--text" width="200" height="56" color="blue-grey" x-large offset-x>
                                <v-icon left>mdi-cloud-download-outline</v-icon>
                                ダウンロード
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="contractFileDownload">
                                <v-list-item-title class="font-size-20">契約文書</v-list-item-title>
                            </v-list-item>
                            <v-list-item link v-if="isConclusion && !isImport" :href="'/documents/document-management/download-consensus-sign/' + id">
                                <v-list-item-title class="font-size-20">合意締結証明書</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row class="grey lighten-3">
                <v-spacer/>
                <!-- サムネイル表示 -->
                <v-col cols="12" class="thumb_wrap text-center" v-for="(dbFile, index) in dbFileList" :key="`1st-${index}`">
                    <div class="thumb" v-show="dbFile.id" @click="toPdfPreview(dbFile)">
                        <v-icon class="plus-icon" color="white">mdi-magnify</v-icon>
                        <pdf-thumb-component v-show="dbFile.id" :pdfData="dbFile.pdfData" :scale="1" max-width="196px" :suffixes="index"></pdf-thumb-component>
                    </div>
                    <div v-show="dbFile.id">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span class="info-to" v-bind="attrs" v-on="on">{{ dbFile.pdfName | omittedText30 }}</span>
                            </template>
                            <span>{{ dbFile.pdfName }}</span>
                        </v-tooltip>
                        
                    </div>
                </v-col>
                <v-spacer/>
            </v-row>
            <v-row justify="center">
                <v-col cols="10">
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <!-- ワークフロー表示 -->
                    <over-view-work-flow-component v-if="!isImport" :destFirstUnsigned="destFirstUnsigned" :reminderEmail="reminderEmail" :isExistsReminderEnable="isExistsReminderEnable" :signatureUrl="signatureUrl"
                        :items="destinationList" :user="user" :isDraft="isDraft" :isRemindStatus="isRemindStatus" :isApplying="isApplying" :isConfReq="isConfReq" :rejectionDate="agreement.rejection_date"></over-view-work-flow-component>
                </v-col>
            </v-row>
            <!-- 下書きの時 -->
            <v-row justify="center" v-if="isDraft && isCreater">
                <v-btn class="white--text" large color="red" :href="'/documents/agreements/continue_edit/' + id">下書きの編集を続ける</v-btn>
            </v-row>
            <v-row v-else></v-row>
        </v-container>
    </div>
</template>
<script>
  import {setTimeoutCheckLogin} from '../../common/loginUtil.js';
  import { signatureMethodMixin } from '../../mixins/signatureMethodMixin.js';
  export default {
    props: {
        user: Object,
        id: Number,
        agreement: Object,
        
        destFirstUnsigned: Object,          // 最初の未署名者
        destinationList: Array,             // 契約送付先リスト
        reminderEmail: Object,              // リマインダ
        isExistsReminderEnable: Boolean,    // 現在のリマインダが有効
        signatureUrl: String,
        
        isCreater: Boolean,         // 作成者(送信元)
        isReceive: Boolean,         // 受信者
        
        // ステータス定数値
        contractStauses :Object,
        openingStauses :Object,
        signStauses :Object,
        
        conclusionDateAndTime: String,  // 契約締結日時
        notExistsFileMessage: String,   // エラーメッセージ
        dbFileList: Array,              // ファイルリスト
        
        referer: {
          type: String,
          default: "/documents/dashboard"
        },
    },
    data() {
        return {
            statusName: "",         // 契約ステータス名
            enableDownload: true,   // ダウンロード有効
            isImport: false,        // インポート書類
            
            isConfReq: false,       // 要確認
            isApplying: false,      // 申請中
            isVerifi: false,        // 確認待ち
            isDraft: false,         // 下書き
            isConclusion: false,    // 締結済み
            isReject: false,        // 却下
            
            isRemindStatus: false,  // リマインド可能なステータス
            
            urlExpireDay: "",       // 有効期限
            remindDay: "",          // リマインド日
            
            openMenu: false,
            confirmDeleteDialog: false,
            confirmCancelDialog: false,
            rejection_reason: "",
            message: {
                success: false,
                text: "",
            },
            sending: false,
        };
    },
    computed: {
        isMessage: {
            get() {
                return this.message.text != '';
            },
            set(value) {
                if (!value) {
                    this.message.text = '';
                }
            }
        },
    },
    filters: {
        omittedText(text) {
         // 11文字目以降は"…"
         return text.length > 10 ? text.slice(0, 10) + "…" : text;
        },
        omittedText30(text) {
         // 20文字目以降は"…"
         return text.length > 30 ? text.slice(0, 30) + "…" : text;
        }
    },
    created() {
        setTimeoutCheckLogin();
        // 契約ステータスの判定
        if (this.agreement.contract_status == this.contractStauses["STATUS_REJECTED"]) {
            this.statusName = "却下";
            this.isReject = true;
            this.enableDownload = false;
            
        } else if (this.agreement.contract_status == this.contractStauses["STATUS_CONCLUSION"]) {
            this.statusName = "締結済み";
            this.isConclusion = true;
            
        } else if (this.isReceive && (this.destFirstUnsigned.opening_status != this.openingStauses["STATUS_NOT_SENT"])
            && (this.destFirstUnsigned.signature_status == this.signStauses["SIGN_STATUS_PENDING"])) {
            // 送信先：送信先（受信した契約のため）
            // 開封ステータス：未送信以外（未送信は前の担当者が完了していないため）
            // 署名ステータス：未承認（未承認以外は後の担当者、あるいは締結・却下となるため）
            this.statusName = "要確認";
            this.isConfReq = true;
            
        } else if (this.agreement.contract_status == this.contractStauses["STATUS_APPLYING"]) {
            this.statusName = "申請中";
            this.isApplying = true;
            
        } else if (this.agreement.contract_status == this.contractStauses["STATUS_VERIFICATION"]) {
            this.statusName = "確認待ち";
            this.isVerifi = true;
            
        } else if (this.agreement.contract_status == this.contractStauses["STATUS_DRAFT"]) {
            this.statusName = "下書き";
            this.isDraft = true;
            this.enableDownload = false;
            
        } else if (this.agreement.contract_status == this.contractStauses["STATUS_IMPORT"]) {
            this.statusName = "インポート書類";
            this.isImport = true;
        }
        
        if (this.dbFileList.length == 0) {
            // ファイルが存在しない場合
            this.message.text = this.notExistsFileMessage;
            this.enableDownload = false;
            return;
        } 
        this.downloadCertificateAgreementLink = '/documents/download-certificate-agreement/' + this.id;
        
        // リマインド可能
        this.isRemindStatus = (this.isApplying || this.isVerifi) && (this.isCreater);
    },
    mixins:[signatureMethodMixin],
    methods: {
        // 遷移元に戻る
        prevPage() {
            window.location.href = this.referer;
        },
        // pdfプレビュー画面へ
        toPdfPreview(dbFile) {
            // 別タブで開く
            window.open('/documents/document-management/preview-contract/' + dbFile.objectId, '_blank');
        },
        contractFileDownload() {
            var self = this;
            this.sending = true;
            try {
                var linked = [];
                this.dbFileList.forEach (function(dbFile) {
                    var filename = dbFile.pdfName;
                    var blob = self.toBlob(dbFile.pdfData);
                    var blobUrl = URL.createObjectURL(blob);
                    var link = document.createElement("a"); // Or maybe get it from the current document
                    link.href = blobUrl;
                    link.download = filename;
                    link.innerHTML = "";
                    document.body.appendChild(link);
                    linked.push(link);
                });
                
                linked.forEach((v) => {
                    v.click();
                    
                    // 例)0.3秒スリープさせる
                    const d1 = new Date();
                    while (true) {
                      const d2 = new Date();
                      if (d2 - d1 > 300) {
                        break;
                      }
                    }
                    URL.revokeObjectURL(v.href);
                    document.body.removeChild(v);
                });
            } catch (e){
                self.message.text = "ダウンロード処理でエラーが発生しました";
                self.message.success = false;
            } finally {
                this.sending = false;
            }

            window.axios.post('/documents/operation-log/save', {
                display_name: '契約概要',
                operation: '書類のダウンロード',
                target: this.agreement.contract_name,
                target_id: this.agreement.object_id,
                table_name: '契約',
                table_id: this.agreement.id
            });
        },
        toBlob: function (base64) {
            var bin = window.atob(base64.replace(/^.*,/, ''));
            var buffer = new Uint8Array(bin.length);
            for (var i = 0; i < bin.length; i++) {
                buffer[i] = bin.charCodeAt(i);
            }
            // Blobを作成
            try {
                var blob = new window.Blob([buffer.buffer], {
                    type: 'application/pdf'
                });
            } catch (e){
                return false;
            }
            return blob;
        },
        // 破棄
        deleteDraft: async function() {
            this.sending = true;
            try {
                var self = this;
                await window.axios
                    .delete('/documents/document-management/delete-draft/' + this.id)
                    .then(function (response) {
                        if (response.data.success) {
                            window.location = "/documents/dashboard";
                        } 
                        else {
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "削除処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        self.message.text = "削除処理に失敗しました";
                        self.message.success = false;
                    }
                );
            }
            finally {
                this.sending = false;
            }
        },
        cancellation: async function() {
            this.sending = true;
            try {
                var self = this;
                await window.axios
                    .post('/documents/document-management/cancellation/' + this.id, {
                        'rejection_reason': self.rejection_reason,
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            var url = location.href;
                            window.location = url;
                        } 
                        else {
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "取り下げ処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        self.message.text = "取り下げに失敗しました";
                        self.message.success = false;
                    }
                );
            }
            finally {
                this.sending = false;
            }
        },
    },
  };
</script>

<style scoped>
    .font-size-20 {
        font-size: 20px;
    }
    .font-weight-bold {
        font-weight: bold;
    }
    .margin-top-30 {
        margin-top: 30px;
    }
    .thumb_wrap {
        width:240px;
        max-width: 240px;
    }
    .plus-icon {
        cursor : pointer;
        opacity: 0;
        position: absolute;
        z-index:99;
        background-color:rgba(0,0,0,0.4);
        border-radius: 50%;
        top: 120px;
        left: 90px;
    }
    .thumb {
        cursor : pointer;
        font-size: 14px;
        margin-left: 20px;
        position: relative;
    }
    .thumb:hover .plus-icon{
        opacity: 1;
        transform: scale(2, 2);
    }
</style>

